<script setup lang="ts">
import type { ARServiceItem } from '@/models/airRoad';

import KTextField from '@/components/fields/KTextField.vue';
import DatePickerField from '@/components/pickerFields/DatePickerField.vue';
import TimePickerField from '@/components/pickerFields/TimePickerField.vue';
import { requiredValidationRule } from '@/helpers/validationRules';

const model = defineModel<ARServiceItem>({
  default: () => ({}),
});
</script>

<template>
  <fieldset
    :class="$style.newAirRoadSpecialOptionDelTimeFieldset"
    data-testid="newAirRoadSpecialOptionDelTimeFieldset"
  >
    <KTextField
      v-model="model.contact_name"
      size="sm"
      label="Name"
      :rules="[requiredValidationRule]"
      :class="$style.field"
    />
    <KTextField
      v-model="model.contact_phone"
      size="sm"
      label="Phone"
      :rules="[requiredValidationRule]"
      :class="$style.field"
    />
    <DatePickerField
      v-model="model._date"
      size="sm"
      label="Date"
      :rules="[requiredValidationRule]"
      :class="$style.field"
    />
    <TimePickerField
      v-model="model._time"
      size="sm"
      label="Time"
      :rules="[requiredValidationRule]"
      :class="$style.field"
    />
  </fieldset>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.newAirRoadSpecialOptionDelTimeFieldset {
}
  .field {
    margin-top: 0.5rem;
  }
</style>
